module.exports = __webpack_public_path__ + "img/icon-book.a817630b.png";